// アップロードする 3 ファイルは gzip 圧縮して送る。API Gateway の 10 MB 上限は送信サイズに掛かるため、
// 展開時 20 MB までの data.json を送るには front での圧縮が必要になる。
// BE は展開して検証し直し、data.json は BE が圧縮し直したものを S3 に保存する（配信時の展開は不要）。

import { gzipSync } from 'fflate';

import { readFileBytes } from './read-file';
import {
  DATA_COMPRESSED_MAX_BYTES,
  DETAILS_COMPRESSED_MAX_BYTES,
  HTML_COMPRESSED_MAX_BYTES,
  formatByteSize,
} from './upload-validation';

const COMPRESSED_LIMITS = {
  dashboard: { fileName: 'dashboard.html', maxBytes: HTML_COMPRESSED_MAX_BYTES },
  data: { fileName: 'data.json', maxBytes: DATA_COMPRESSED_MAX_BYTES },
  details: { fileName: 'details.txt', maxBytes: DETAILS_COMPRESSED_MAX_BYTES },
} as const;

/** multipart のパート名。 */
export type UploadPart = keyof typeof COMPRESSED_LIMITS;

/**
 * ファイルを gzip 圧縮した File を返す。圧縮後も圧縮時の上限を超える場合は例外にする
 * （そのまま送ると API Gateway が 413 を返し、理由の分からないエラーになるため）。
 */
export async function gzipUploadFile(file: File, part: UploadPart): Promise<File> {
  const { fileName, maxBytes } = COMPRESSED_LIMITS[part];
  // テキストに読み直すと BOM 除去や不正 UTF-8 の置換が起き BE の検証対象が変わるため、バイト列のまま圧縮する。
  const compressed = gzipSync(await readFileBytes(file), { mtime: 0 });
  if (compressed.length > maxBytes) {
    throw new Error(
      `${fileName} は圧縮後 ${formatByteSize(maxBytes)} 以下にしてください（圧縮後 ${formatByteSize(compressed.length)}）。画像の埋め込みなど、圧縮しにくいデータを減らしてください`,
    );
  }
  return new File([compressed], `${fileName}.gz`, { type: 'application/gzip' });
}
